module.exports = __webpack_public_path__ + "img/development _history.d706121d.jpg";